<template>
    <div>
        <div class="row">
            <!--<div class="col-lg-12 mt-3 mb-1 text-center">-->
            <!--<div class="category-item bg-info-grad mb-2" v-for="(item, index) in categories" @click="onCategoryClicked(index)">-->
            <!--<h5 class="text-white">{{item.name}}</h5>-->
            <!--</div>-->
            <!--</div>-->
            <div class="col-9  m-2" v-if="!isProducer">
                <div class="input-group">
                    <div class="input-group-prepend">
                    <span class="input-group-text">
                        <i class="fa fa-search"></i>
                    </span>
                    </div>
                    <input type="text" class="form-control" placeholder="جستجو..." @input="onSearchInput"
                           v-model="searchString">
                </div>
            </div>
            <div class="col-2 m-2" v-if="!isProducer">
                <button class="btn btn-secondary float-left" data-toggle="modal" data-target="#provider-modal"
                        @click="onModalButtonClicked">افزودن تامین کننده
                </button>
            </div>
            <div class="col-lg-12 mt-lg-5  justify-content-center" v-if="providers.length < 1">
                <h3 class="text-center no-item-alert">تامین کننده ثبت نشده است!</h3>
            </div>
            <div class="col-lg-2 col-md-3 col-sm-4 product-container  mt-lg-5 justify-content-center"
                 v-for="(item, index) in providers">
                <div :class="{active: item.unitVal > 0}" class="card product mt-2 mb-2"
                     @click="onOutsourceClicked(item)">
                    <div class="row p-2">
                        <!--<div class="col-12">-->
                        <!--<img src="../assets/img/placeholder.png" class="img-fluid w-100">-->
                        <!--</div>-->
                        <div class="col-12">
                            <h4 class="text-center">{{item.outSourceName}}</h4>
                            <span>شماره تماس:</span>
                            <span>{{item.phoneNumber}}</span>
                            <br/>
                            <span>کد ملی:</span>
                            <span>{{item.branchCode}}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="sk-circle mt-5" id="loading">
                <div class="sk-circle1 sk-child"></div>
                <div class="sk-circle2 sk-child"></div>
                <div class="sk-circle3 sk-child"></div>
                <div class="sk-circle4 sk-child"></div>
                <div class="sk-circle5 sk-child"></div>
                <div class="sk-circle6 sk-child"></div>
                <div class="sk-circle7 sk-child"></div>
                <div class="sk-circle8 sk-child"></div>
                <div class="sk-circle9 sk-child"></div>
                <div class="sk-circle10 sk-child"></div>
                <div class="sk-circle11 sk-child"></div>
                <div class="sk-circle12 sk-child"></div>
            </div>
            <div v-if="providers.length < dataCount" class="col-lg-12 text-center" @click="getProviders">
                <button class="btn btn-success">نمایش تامین کننده های بیشتر</button>
            </div>
        </div>
        <div class="modal fade" id="provider-modal" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header bg-warning-grad glow-warning">
                        <h5 v-if="params.mode === 'create'" class="modal-title text-white">افزودن تامین کننده</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <!--<div class="col-lg-6 offset-lg-3 mb-2">-->
                            <!--<div class="input-group">-->
                            <!--<div class="input-group-prepend">-->
                            <!--<span class="input-group-text">دسته بندی</span>-->
                            <!--</div>-->
                            <!--<vs-select :data="categories" :selected-val="preselectedCategory" :mode="'create'"-->
                            <!--:header="{multiple: false, label: 'name'}" @onChange="onCategoryChange"></vs-select>-->
                            <!--</div>-->
                            <!--</div>-->
                            <!--<div class="col-lg-3 text-right">-->
                            <!--<button class="btn btn-primary bg-danger-grad border-0" @click="onAddCategoryClicked" data-toggle="tooltip" data-placement="bottom" title="افزودن دسته بندی">-->
                            <!--<i class="fa fa-plus"></i>-->
                            <!--</button>-->
                            <!--</div>-->
                            <div class="col-lg-6 mb-2">
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">نام تامین کننده</span>
                                    </div>
                                    <input class="form-control" type="text" v-model="provider.outSourceName">
                                </div>
                            </div>
                            <div class="col-lg-6 mb-2">
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">شماره تماس</span>
                                    </div>
                                    <input class="form-control" type="number" v-model="provider.phoneNumber">
                                </div>
                            </div>
                            <div class="col-lg-6 mb-2">
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">کد/شناسه ملی</span>
                                    </div>
                                    <input class="form-control" type="number" v-model="provider.branchCode">
                                </div>
                            </div>
                            <!--<div class="col-lg-4 mb-2">-->
                            <!--<div class="input-group">-->
                            <!--<div class="input-group-prepend">-->
                            <!--<span class="input-group-text">کد اقتصادی</span>-->
                            <!--</div>-->
                            <!--<input class="form-control" type="number" v-model="provider.shebaCode">-->
                            <!--</div>-->
                            <!--</div>-->
                            <div class="col-lg-6 mb-2">
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">کد پستی</span>
                                    </div>
                                    <input class="form-control" type="number" v-model="provider.accountNumber">
                                </div>
                            </div>
                            <div class="col-lg-12 mb-2">
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">آدرس</span>
                                    </div>
                                    <input class="form-control" type="text" v-model="provider.address">
                                </div>
                            </div>
                            <div class="col-lg-12 mb-2">
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">کد اقتصادی(در صورت وارد کردن صورتحساب مالیاتی نوع 1 ارسال میشود)</span>
                                    </div>
                                    <input class="form-control" type="number" v-model="provider.branchName">
                                </div>
                            </div>
                        </div>
                        <div class="input-group mt-2">
                            <div class="input-group-prepend">
                                <span class="input-group-text">توضیحات</span>
                            </div>
                            <input class="form-control" type="text" v-model="provider.description">
                        </div>
                    </div>
                    <div class="modal-footer d-block">
                        <div class="col-5">
                            <button type="button" class="btn btn-secondary mt-2" data-dismiss="modal">بستن</button>
                            <button type="button" class="btn btn-primary mt-2" @click="onModalOk">ذخیره</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import * as $ from 'jquery';
    import axios from 'axios';
    import Vue from 'vue';
    import BaseService from "../_framework/api/BaseService";
    import Utils from "../_framework/utils/Utils";

    $(function () {
        var pos1 = 0;
        $(window).scroll(function () {
            var pos2 = $(window).scrollTop();
            if (pos2 > pos1) {
                $(".search-area").addClass("hidden");
            }
            if (pos1 > pos2) {
                $(".search-area").removeClass("hidden");
            }
            pos1 = pos2;
        })
    });

    //$(".product-container:nth-child(1)").css("background-color","green");
    $(".voucher-modal-button").click(() => {
        $("#voucherData").modal("show");
    });

    export default {
        name: 'buy',
        components: {},
        data() {
            return {
                providers: [],
                categories: [],
                queryParams: {
                    pageSize: 10000,
                    pageIndex: 0,
                    name: "",
                    // categoryId: 0
                },
                searchString: "",
                modalProductName: "",
                cart: [],
                dataCount: 0,
                categoryClicked: false,
                params: {
                    mode: 'create'
                },
                provider: {
                    phoneNumber: "",
                    description: "",
                    outSourceName: "",
                    type: 5
                },
                isProducer: false,
                isSending: false,
                producerMobile: "",
                companyPostName: "",

            }
        },
        mounted() {
            const cc = localStorage.getItem("salemali_close");
            if (cc !== undefined && cc != null && cc === "true") {
                Utils.handleErrorWithNotification("سال مالی بسته شده است و امکان ثبت جدید وجود ندارد", this.$noty);
                this.$router.push({name: 'home'});
            }
            /*axios.defaults.baseURL = window.API_URL;
            axios.get('outsource/getlist/2', this.queryParams).then(response => {
                this.providers = response.data.data;
            }).catch(error => {
            });
            axios.get('categories/getall').then(response => {
                this.categories = response.data;
            }).catch(error => {
            });*/
            if (localStorage.getItem("auth_token") === null) {
                this.$noty.error('لطفا مجددا وارد شوید!');
                this.$router.push({name: 'login'});
            } else {
                // new BaseService('categories').getAll().then(response => {
                //     this.categories = response.data;
                //     $("#loading").hide();
                // }).catch(error => {
                //     // error
                //     Utils.handleErrorWithNotification(error.response.message, this.$noty);
                // });
                // this.getFirstList();
                this.getProductList();
            }

            this.companyPostName = localStorage.getItem("companyPostName");

            if (this.companyPostName === 'تامین کننده') {
                this.isProducer = true;
                this.producerMobile = localStorage.getItem("phoneNumber");
                console.log(this.producerMobile);
            }
        },
        methods: {
            getFirstList() {
                new BaseService('outsource', '/getlist/5').getList(this.queryParams).then(response => {
                    if (this.isProducer) {
                        for (let item of response.data.data) {
                            console.log(item)
                        }
                    } else {
                        this.providers = response.data.data;
                        this.dataCount = response.data.count;
                        $("#loading").hide();
                    }
                }).catch(error => {
                    // error
                    Utils.handleErrorWithNotification(error.response.message, this.$noty);
                });
            },
            getProductList() {
                new BaseService('outsource', '/getlist/5').getList(this.queryParams).then(response => {
                    if (this.isProducer) {
                        for (let item of response.data.data) {
                            if (item.phoneNumber === this.producerMobile) {
                                this.providers.push(item);
                            }
                        }
                        $("#loading").hide();
                    } else {
                        this.providers = response.data.data;
                        $("#loading").hide();
                    }
                }).catch(error => {
                    // error
                    Utils.handleErrorWithNotification(error.response.message, this.$noty);
                });
            },
            getProviders() {
                this.queryParams.pageIndex++;
                $("#loading").show();
                this.getProductList();
            },
            onSearchInput() {
                this.queryParams.name = this.searchString;
                this.queryParams.pageIndex = 0;
                $("#loading").show();
                this.getProductList();
            },

            onCategoryClicked(index) {
                this.categoryClicked = true;
                this.queryParams.categoryId = this.categories[index].id;
                $("#loading").show();
                this.getProductList();
            },
            onOutsourceClicked(item) {
                if (this.isProducer) {
                    this.$router.push({
                        name: 'buy-from-outsource-old',
                        params: {
                            id: item.id
                        }
                    });
                } else {
                    this.$router.push({
                        name: 'buy-from-outsource',
                        params: {
                            id: item.id,
                            outSourceName:item.outSourceName
                        }
                    });
                }
            },
            onModalButtonClicked() {
                this.params.mode = 'create';
                Utils.resetObject(this.provider);
                this.preselectedCategory = {};
                this.provider.type = 5;
            },
            onModalOk() {
                if (this.params.mode === 'create') {
                    this.onCreate(this.provider);

                }
            },
            onCreate(provider) {
                if(!this.isSending) {
                    this.isSending = true;
                    // console.log(provider)
                    provider.rowVersion = this.generateUuid();
                    new BaseService('outsource').create(provider).then(response => {
                        this.$noty.success("تامین کننده با موفقیت افزوده شد.");
                        $("#provider-modal").modal("hide");
                        this.queryParams.pageIndex = 0;
                        this.getProductList();
                        this.isSending = false;
                    }).catch(error => {
                        this.isSending = false;
                        Utils.handleErrorWithNotification(error.message, this.$noty);
                    });
                }
            },

        }
    }
</script>

<style scoped>
    #loading {
        position: absolute;
        top: calc(40% - 55px);
        left: calc(50% - 55px);
    }
</style>